import { action, atom } from '@reatom/framework'
import { match } from 'ts-pattern'

import { Network, selectedNetworkAtom } from '@root/entities/network'

import { CurrencyModel } from '../model'

export const nativeNetworkCurrencyAtom = atom((ctx) => {
  const network = ctx.spy(selectedNetworkAtom)
  return CurrencyModel.nativeOf(network)
}, 'nativeNetworkCurrencyAtom')

export const nativeNetworkUsdTokenAtom = atom((ctx) => {
  const network = ctx.spy(selectedNetworkAtom)
  return match(network)
    .with(Network.Ethereum, () => CurrencyModel.UsdtEvm)
    .with(Network.Solana, () => CurrencyModel.UsdcSol)
    .with(Network.Ton, () => CurrencyModel.UsdtTon)
    .with(Network.Base, () => CurrencyModel.UsdtBase)
    .with(Network.Bsc, () => CurrencyModel.UsdtBsc)
    .exhaustive()
}, 'nativeNetworkUsdTokenAtom')

// eslint-disable-next-line @reatom/unit-naming-rule
export const currencyAddLogoEvent = action<CurrencyModel>(
  'currencyAddLogoEvent',
)

export * from './currency-requests'
export * from './reatom-currency-icon'
export * from './currency-registry'
